/**
 * 365reset — Six health sectors.
 * Central definition used throughout the app for consistent
 * labels, colours, and ordering.
 */

export const SECTORS = [
  {
    key:         'financial',
    label:       'Financial',
    description: 'Money, spending, savings, financial security',
    color:       '#C4714A',   // terracotta
    bgClass:     'bg-amber-50',
    ringClass:   'ring-amber-400',
    textClass:   'text-amber-700',
    badgeClass:  'bg-amber-100 text-amber-800',
    emoji:       '💰',
  },
  {
    key:         'career',
    label:       'Career',
    description: 'Work, business, purpose, professional growth',
    color:       '#4A7BC4',
    bgClass:     'bg-blue-50',
    ringClass:   'ring-blue-400',
    textClass:   'text-blue-700',
    badgeClass:  'bg-blue-100 text-blue-800',
    emoji:       '💼',
  },
  {
    key:         'emotional',
    label:       'Emotional',
    description: 'Feelings, relationships, connection, wellbeing',
    color:       '#C44A7B',
    bgClass:     'bg-rose-50',
    ringClass:   'ring-rose-400',
    textClass:   'text-rose-700',
    badgeClass:  'bg-rose-100 text-rose-800',
    emoji:       '💗',
  },
  {
    key:         'mental',
    label:       'Mental',
    description: 'Mindset, focus, learning, cognitive health',
    color:       '#7B4AC4',
    bgClass:     'bg-purple-50',
    ringClass:   'ring-purple-400',
    textClass:   'text-purple-700',
    badgeClass:  'bg-purple-100 text-purple-800',
    emoji:       '🧠',
  },
  {
    key:         'physical',
    label:       'Physical',
    description: 'Movement, sleep, nutrition, body health',
    color:       '#4AC47B',
    bgClass:     'bg-green-50',
    ringClass:   'ring-green-400',
    textClass:   'text-green-700',
    badgeClass:  'bg-green-100 text-green-800',
    emoji:       '🏃',
  },
  {
    key:         'spiritual',
    label:       'Spiritual',
    description: 'Faith, meaning, values, inner peace',
    color:       '#4A4AC4',
    bgClass:     'bg-indigo-50',
    ringClass:   'ring-indigo-400',
    textClass:   'text-indigo-700',
    badgeClass:  'bg-indigo-100 text-indigo-800',
    emoji:       '✨',
  },
];

export const SECTOR_MAP = Object.fromEntries(SECTORS.map(s => [s.key, s]));

/** Default comfort zones shown on first onboarding — mid-range, open. */
export const DEFAULT_COMFORT_ZONES = Object.fromEntries(
  SECTORS.flatMap(s => [
    [`${s.key}_comfort_min`, 4],
    [`${s.key}_comfort_max`, 7],
  ])
);
